/**
 * This file was auto-generated by Fern from our API Definition.
 */

export class TruvityTimeoutError extends Error {
    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, TruvityTimeoutError.prototype);
    }
}
